import { api } from "../api";

async function getMyProperties(userId: string) {
  const { data } = await api.get(`/propertyIdUser/${userId}`);

  return data;
}

async function getPropertyById(id: string) {
  const { data } = await api.get(`/property/${id}`);

  return data;
}

// ToDo: Remover any
const createProperty = async (data: any) => {
  await api.post("/property", data);
};

// ToDo: Remover any
const updateProperty = async ({ id, data }: any) => {
  await api.put(`/property/${id}`, data);
};

export { getMyProperties, getPropertyById, createProperty, updateProperty };
